export default {
  NONE: 'N',
  SML: 'S',
  FARMPAY: 'F'
}
